import React from 'react';
import style from "../Friends.module.css";


const Friend = (props) => {
    console.log(props.id);
    let path = '/react/dialogs/user' + props.id;
    return (
        <div className={style.friendCard}>
            <figure className={style.cardTop}>
                <img className={style.bgImg} src={props.bgImg} alt="avatar_background-img"/>
                <span className={style.followersSpan}>Followers: {props.followers}</span>


                <img className={style.friendAvatar} src={props.img} alt="avatar_img"/>
            </figure>
            <div className={style.cardCapture}>
                <a className={style.friendName} href="#" title>{props.name}</a>
                <span>{props.location}</span>
            </div>
            <ul className={style.friendInfo}>
                <li><span>Friends:</span> {props.friends}</li>
                <li><span>Videos:</span> {props.videos}</li>
                <li><span>Photos:</span> {props.photos}</li>
                <li><span>Posts:</span> {props.posts}</li>
                <li><span>Since:</span> {props.since}</li>

            </ul>
            <a className={style.sendMessage} href={path}>Message</a>

        </div>
    );
};

export default Friend;